import gql from 'graphql-tag'

const clientiUI = gql`
  query clientiUI {
    clientiUI @client {
      sortFields
      searchQuery
      searchQueryDebounced
      onlyDaRicontattare
      zona
      interesse
      zonaEsclusa
      interesseEscluso
      page
    }
  }
`

export default clientiUI



// WEBPACK FOOTER //
// ./src/graphql/queries/clientiUI.js